import React from 'react'
import Section from '../Section'
import InputField from '../StaticLabelInput'
import notesIcon from 'assets/images/contacts/Editor/editor-note-20.svg'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'
import deleteIcon from 'assets/images/button-remove.svg'

interface MemosProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Memos = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: MemosProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="notes"
      labelList={editData.isPersonal ? null : []}
      icon={notesIcon}
      addButtonLabel={t('contact.menu.addMemo')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
      useCustomLabelRender={(datas) => {
        return (
          <>
            {datas.length > 0 &&
              datas.map((data: any, index: number) => (
                <div key={index} className={styles.memoFieldWrapper}>
                  <InputField
                    key={index}
                    id={`notes-${index}`}
                    label={t('contact.property.memo')}
                    value={data.value}
                    useTextArea={true}
                    onChange={(value) => onFieldChange('notes', index, value)}
                  />
                  {!editData.isPersonal && (
                    <div className={styles.deleteButton} onClick={() => onDelete('notes', index)}>
                      <img src={deleteIcon} alt="delete" />
                    </div>
                  )}
                </div>
              ))}
          </>
        )
      }}
    />
  )
}

export default Memos
